export const CHANGE_LOCALE = '@portal/CHANGE_LOCALE';

export function changeLocale(languageLocale) {
  return {
    type: CHANGE_LOCALE,
    payload: { languageLocale },
  };
}
